export const getBarColor = ({ barColor }) =>
  `background-color: ${barColor || 'black'}`



// WEBPACK FOOTER //
// ./src/node_modules/components/functions/getBarColor.js